import React from 'react'
import { HashLink as Link } from 'react-router-hash-link'
import { connect } from 'react-redux'
import { acceptCookie } from '../actions'
import { themeColors } from '../styles/theme'
import RaisedButton from 'material-ui/RaisedButton'

const styles = {
  containerStyle: {
    position: 'fixed',
    display: 'flex',
    paddingLeft: 15,
    paddingRight: 15,
    bottom: 0,
    left: 0,
    width: '100%',
    zIndex: 9999999,
    backgroundColor: themeColors.primary,
    height: 80,
  },
  desktopContainer: {
    display: 'flex',
    width: '100%',
  },
  text: {
    marginTop: 25,
    color: themeColors.white,
    paddingRight: 5,
  },
  link: {
    paddingLeft: 5,
    paddingRight: 5,
    color: themeColors.energized,
  },
  btn: {
    marginLeft: 'auto',
    marginTop: 20,
    marginBottom: 25,
  },
  mobileContainer: {
    marginTop: 10,
    margin: 'auto',
    textAlign: 'center',
  },
  textMobile: {
    margin: 'auto',
    color: themeColors.white,
    paddingBottom: 5,
  },
  btnMobile: {
    margin: 'auto',
  },
}

const CookieConsent = ({ cookieAccepted, acceptCookie }) => {
  if (!cookieAccepted) {
    return (
      <div style={styles.containerStyle}>
        <div className="hidden-xs hidden-sm" style={styles.desktopContainer}>
          <h4 style={styles.text}>
            Questo sito web utilizza cookies per garantirti la miglior esperienza utente
            {' '}
            <Link to="/come-funziona#cookie-policy" style={styles.link}>
              Maggiori informazioni
            </Link>
          </h4>
          <RaisedButton
            label="Ho capito"
            onClick={acceptCookie}
            style={styles.btn}
            labelColor={themeColors.positive}
          />
        </div>
        <div className="hidden-lg hidden-md" style={styles.mobileContainer}>
          <h5 style={styles.textMobile}>
            Questo sito web utilizza cookies per garantirti la miglior esperienza utente
            {' '}
            <Link to="/come-funziona#cookie-policy" style={styles.link}>
              Maggiori informazioni
            </Link>
          </h5>
          <RaisedButton
            label="Ho capito"
            onClick={acceptCookie}
            style={styles.btnMobile}
            labelColor={themeColors.positive}
          />
        </div>
      </div>
    )
  }
  return null
}

const mapStateToProps = state => ({
  cookieAccepted: state.cookieAccepted,
})

export default connect(mapStateToProps, {
  acceptCookie,
})(CookieConsent)



// WEBPACK FOOTER //
// ./src/common/CookieConsent.js